import React, { useContext } from "react";
import LayoutContext from "../../context/layout/LayoutContext";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";

const useStyles = makeStyles((theme) => ({
  // alert: { marginBottom: theme.spacing(1) },
  alert: {
    zIndex: theme.zIndex.drawer + 1,
    "& > * + *": {
      marginTop: theme.spacing(1),
    },
    // width: "40%",
    width: "auto",
    minWidth: "40%",
    maxWidth: "70%",
    position: "fixed",
  },
  successAlertColor: {
    backgroundColor: alpha("#e6ffcc", 0.9),
  },
  errorAlertColor: {
    backgroundColor: alpha("#ffc2b3", 0.9),
  },
  warningAlertColor: {
    backgroundColor: alpha("#fff6c0", 0.9),
  },
  infoAlertColor: {
    backgroundColor: alpha("#c0e4ff", 0.9),
  },
}));

const Alerts = () => {
  const classes = useStyles();
  const { alerts } = useContext(LayoutContext);

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        direction="column"
        justifyContent="center"
        className={classes.alert}
      >
        {alerts.length > 0 &&
          alerts.map((alert) => {
            let color = "";

            if (alert.type === "success") color = "successAlertColor";
            else if (alert.type === "error") color = "errorAlertColor";
            else if (alert.type === "warning") color = "warningAlertColor";
            else if (alert.type === "info") color = "infoAlertColor";

            return (
              // <Alert key={alert.id} severity={alert.type} className={classes.alert}>
              //   {alert.message}
              // </Alert>

              <Alert
                key={alert.id}
                severity={alert.type}
                className={classes[color]}
              >
                {/* <AlertTitle>
                                          <strong>{alert.type}</strong>
                                        </AlertTitle> */}{" "}
                {alert.message}{" "}
              </Alert>
            );
          })}{" "}
      </Grid>{" "}
    </Grid>
  );
};

export default Alerts;
